import { LOGGED_OUT } from 'actions/types';
export const SET_PENDING_PRIMARY_ADDRESS = 'CREDIT_SCORE_SET_PENDING_PRIMARY_ADDRESS';
export const SET_PENDING_PREVIOUS_ADDRESS = 'CREDIT_SCORE_SET_PENDING_PREVIOUS_ADDRESS';
export const SET_PENDING_MOVING_DATE = 'CREDIT_SCORE_SET_PENDING_MOVING_DATE';
export const CLEAR_CREDIT_SCORE_ONBOARDING = 'CREDIT_SCORE_CLEAR_ONBOARDING';
const initialState = {};
const creditScoreOnboarding = (state = initialState, action) => {
    switch (action.type) {
        case SET_PENDING_PRIMARY_ADDRESS:
            return { ...state, pendingPrimaryAddress: action.payload };
        case SET_PENDING_PREVIOUS_ADDRESS:
            return { ...state, pendingPreviousAddress: action.payload };
        case SET_PENDING_MOVING_DATE:
            return { ...state, pendingMovingDate: action.payload };
        case CLEAR_CREDIT_SCORE_ONBOARDING:
            return initialState;
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default creditScoreOnboarding;
// Action creators
export const setPendingPrimaryAddress = (address) => ({
    type: SET_PENDING_PRIMARY_ADDRESS,
    payload: address,
});
export const setPendingPreviousAddress = (address) => ({
    type: SET_PENDING_PREVIOUS_ADDRESS,
    payload: address,
});
export const setPendingMovingDate = (date) => ({
    type: SET_PENDING_MOVING_DATE,
    payload: date,
});
export const clearCreditScoreOnboarding = () => ({
    type: CLEAR_CREDIT_SCORE_ONBOARDING,
});
